import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Radios, Field } from '@ontruck/orc';

const t = {
  siret_number: 'Siret number',
  siretPlaceholder: 'Siret',
  vat_exempt: 'Not subject to VAT?',
};

const DynamicCarrierField = ({ className, field, handleFieldChange, carrier }) => {
  const fieldName = field?.label;
  const fieldType = field?.type;

  const checkDependencyToRender = useCallback(() => {
    if (!field?.dependency) return true;
    return Object.keys(field.dependency).every((item) => carrier[item] === field.dependency[item]);
  }, [field, carrier]);

  const getRadioValue = useCallback(() => {
    if (carrier.extra_fields && fieldName in carrier.extra_fields)
      return carrier.extra_fields[fieldName].toString();
  }, [carrier, fieldName]);

  const getTextValue = useCallback(
    () => carrier.extra_fields && carrier.extra_fields[fieldName],
    [carrier, fieldName]
  );

  if (!field || !checkDependencyToRender()) return null;

  return (
    <div className={className} data-testid="dynamic-carrier-field">
      <div className="dynamic-carrier-field">
        {fieldType === 'text' && (
          <Field
            onChange={(e, { name, value }) =>
              handleFieldChange('extra_fields')({
                ...carrier.extra_fields,
                [fieldName]: value,
              })
            }
            name={fieldName}
            id={fieldName}
            label={t[fieldName]}
            size="M"
            placeholder={t[`${fieldName}Placeholder`]}
            value={getTextValue(fieldName)}
            className="dynamic-carrier-field__field"
          />
        )}
        {fieldType === 'radio' && (
          <Radios
            size="M"
            legend={t[fieldName]}
            name={fieldName}
            items={field.choices.map((choice) => ({
              label: choice.label,
              value: choice.value.toString(),
            }))}
            value={getRadioValue(fieldName)}
            onChange={(e, { name, value }) => {
              handleFieldChange('extra_fields')({
                ...carrier.extra_fields,
                [fieldName]: value === 'true',
              });
            }}
          />
        )}
      </div>
    </div>
  );
};
DynamicCarrierField.propTypes = {
  className: PropTypes.string,
  field: PropTypes.object.isRequired,
  carrier: PropTypes.object.isRequired,
  handleFieldChange: PropTypes.func.isRequired,
};
export default DynamicCarrierField;
